import { h } from 'preact';
import './index.css';

const AnimationContainer = (props) => (
  <div className="animate-container">{props.children}</div>
);

export default AnimationContainer;
